export default "__VITE_ASSET__pb0q0Gqe__"